import { CustomButton } from "@/components/ui/Buttons";
import { useGlobalContext } from "@/context/GlobalContext";
import { PlusCircle } from "lucide-react";
import { Link } from "react-router-dom";

interface WalletBalanceSectionProps {
  balance: number;
  onAddBankAccount: () => void;
  onWithdraw: () => void;
}

const WalletBalanceSection: React.FC<WalletBalanceSectionProps> = ({
  balance,
  onAddBankAccount,
  onWithdraw,
}) => {
  const { ucdT } = useGlobalContext();

  return (
    <div className="flex flex-col md:flex-row justify-between md:items-center pb-5 border-b border-[#E4E7EC] gap-y-4">
      <div className="space-y-2">
        <h5 className="text-[#667085] text-sm leading-[18px] font-medium">
          Wallet Balance
        </h5>
        <h3 className="text-[#FF6600] text-2xl leading-9 tracking-[-1%] font-semibold">
          {ucdT?.symbols || "₹"} {balance}
        </h3>
      </div>
      <div>
        <div className="flex justify-between gap-x-4">
          <CustomButton
            id="btn-add-bank-account"
            variant="outline"
            fontSize="12px"
            fontWeight="500"
            color="black"
            border="1px solid #D0D5DD"
            borderRadius="8px"
            padding="6px 12px"
            className="tracking-[-0.75%] leading-[18px] shadow-sm flex items-center gap-2"
            onClick={onAddBankAccount}
          >
            <PlusCircle size={14} /> Add new bank account
          </CustomButton>
          <CustomButton
            fontSize="12px"
            fontWeight="500"
            onClick={onWithdraw}
            color="white"
            backgroundColor="#000000"
            border="1px solid #D0D5DD"
            borderRadius="8px"
            padding="6px 12px"
            className="tracking-[-0.75%] leading-[18px] shadow-sm"
          >
            Withdraw
          </CustomButton>
        </div>
        <Link to={"/withdraw-requests"}>
          <p className="text-xs text-gray-500 font-medium text-end pt-5 ">
            View Withdraw Requests
          </p>
        </Link>
      </div>
    </div>
  );
};

export default WalletBalanceSection;
